'use client'

import { usePathname } from 'next/navigation'
import { useState, useEffect } from 'react'
import { useLayoutControl } from './layoutControl'

import MobileHeader from '@/components/headers/MobileHeader'
import MobileFooter1 from '@/components/footers/MobileFooter1'
import Footer8 from '@/components/footers/Footer8'
import Header9 from '@/components/headers/Header9'
import Header14 from '@/components/headers/Header14'

import styles from './layoutClient.module.css'

function DesktopHeader({
  headerStyle,
  cusomNav,
  homeContent,
  brand,
  storeInfo,
  categoryItems,
}) {
  switch (headerStyle?.LogoPosition) {
    case 1:
      return (
        <Header9
          cusomNav={cusomNav}
          headerStyle={headerStyle}
          content={homeContent}
          brand={brand}
          storeInfo={storeInfo}
          categoryItems={categoryItems}
        />
      )
    case 2:
      return (
        <Header14
          cusomNav={cusomNav}
          headerStyle={headerStyle}
          content={homeContent}
          brand={brand}
          storeInfo={storeInfo}
          categoryItems={categoryItems}
        />
      )
    default:
      return null
  }
}

export default function LayoutClient({
  children,
  headerStyle,
  homeContent,
  brand,
  cusomNav,
  categoryItems,
  storeInfo,
}) {
  /** ✅ 唯一的 Header/Footer 開關來源 */
  const { hideHeader, hideFooter } = useLayoutControl()

  const pathname = usePathname()
  const [from, setFrom] = useState(null)
  useEffect(() => {
    setFrom(new URLSearchParams(window.location.search).get('from'))
  }, [pathname])
  const CartButtonEnable = storeInfo?.CartButtonEnable

  const isForLine =
    pathname.includes('for_line') ||
    pathname.includes('line/auth') ||
    pathname.includes('barcode') ||
    pathname.includes('royalelastics_image') ||
    from === 'line'

  return (
    <div className={styles.siteWrapper}>
      {/* ===== Header ===== */}
      {!isForLine && !hideHeader && (
        <>
          {/* 桌機 Header */}
          <div className="d-none d-lg-block">
            <DesktopHeader
              headerStyle={headerStyle}
              cusomNav={cusomNav}
              homeContent={homeContent}
              brand={brand}
              storeInfo={storeInfo}
              categoryItems={categoryItems}
            />
          </div>

          {/* 手機 Header */}
          <div className="d-block d-lg-none">
            <MobileHeader
              headerStyle={headerStyle}
              brand={brand}
              cusomNav={cusomNav}
              categoryItems={categoryItems}
              storeInfo={storeInfo}
            />
          </div>
        </>
      )}

      {/* ===== Page ===== */}
      <main className={styles.siteMain}>{children}</main>

      {/* ===== Footer ===== */}
      {!isForLine && !hideFooter && CartButtonEnable && (
        <>
          {/* 桌機 Footer */}
          <Footer8 storeInfo={storeInfo} />

          {/* 手機 Footer */}
          <MobileFooter1 storeInfo={storeInfo} />
        </>
      )}
    </div>
  )
}
